import React from 'react'
import config from './config'

export default function useInput(props) {
  const {
    value = '',
    errorMessage = 'Por favor, preencha este campo corretamente.',
    hasError = false,
    ...rest
  } = props

  const [inputType, setInputData] = React.useState({
    title: 'text',
    type: 'text'
  })
  const [currentValue, setCurrentValue] = React.useState(value)
  const [hidden, setHidden] = React.useState(true)
  const [loading, setLoading] = React.useState(true)
  const [mask, setMask] = React.useState('')
  const [error, setError] = React.useState({
    message: errorMessage,
    hasError: hasError
  })

  function handleChange(event) {
    const { value } = event.target
    setCurrentValue(value)
  }

  function beforeMaskedStateChange({ nextState }) {
    if (!nextState) return nextState
    let { value } = nextState
    let newValue = value.replace(/\D/g, '')

    if (inputType.title === 'phone') {
      value = phoneFormat(value)
      newValue.length <= 10
        ? setMask('(99) 9999-99999')
        : setMask('(99) 99999-9999')
    }

    if (inputType.title === 'cpf-cnpj' || inputType.title === 'cpfCnpj') {
      value = cpfCnpjFormat(value)
      newValue.length > 11
        ? setMask('99.999.999/9999-99')
        : setMask('999.999.999-999')
    }

    return {
      ...nextState,
      value
    }
  }

  function phoneFormat(value) {
    let newValue = value.replace(/\D/g, '')

    if (newValue.length < 10) return value
    if (newValue.length == 10)
      return newValue.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3')

    return newValue.replace(/^(\d{2})(\d{5})(\d{4})(\d*)$/, '($1) $2-$3')
  }

  function cpfCnpjFormat(value) {
    let newValue = value.replace(/\D/g, '')

    return newValue.length === 11
      ? newValue
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
      : value
  }

  function handleBlur(event) {
    if (
      typeof inputType.fn !== 'undefined' &&
      typeof inputType.fn === 'function'
    ) {
      const isValid = inputType.fn(event.target.value, props?.errorMessage)
      setError({
        hasError: isValid.hasError,
        message: errorMessage
      })
    }
    if (props?.required) {
      const isEmpty = event.target.value.length <= 0
      setError({
        hasError: isEmpty,
        message: errorMessage
      })
    }

  }

  const fetchInputType = () => {
    const currentInput =
      config
        .filter((it) => Object.keys(props).includes(it.title))
        .reduce((_, item) => ({ ...item }), {}) || InitialState

    return Promise.resolve(currentInput)
  }

  React.useEffect(() => {
    if (!!value) {
      setCurrentValue(value)
    }
  }, [value])

  React.useEffect(() => {
    fetchInputType().then((res) => {
      setInputData(res)
      setMask(res.mask || mask)
      setLoading(false)
    })
  }, [])

  function renderOption(options) {
    return options?.map((option, index) => (
      <option key={index} value={option.value}>
        {option.label}
      </option>
    ))
  }

  return {
    config,
    value,
    currentValue,
    hidden,
    setHidden,
    error,
    loading,
    beforeMaskedStateChange,
    handleChange,
    handleBlur,
    setCurrentValue,
    inputType,
    renderOption,
    mask,
    setMask,
    rest
  }
}
